import Super from '@simplepractice/ember-messaging-client/serializers/messaging-conversation';

export default Super.extend({});
